import i18n from "~/components/i18n"

export const getSilageColumnTypes = (key) => [
  {
    key: `${key}GhgEmissionPerHa`,
    name: 'THG-Emissionen je Hektar',
    total: true,
    unit: 'kg CO₂-Äq./ha'
  },
  {
    key: `${key}Seed`,
    name: 'Saatgut',
    unit: 'kg CO₂-Äq./ha',
    pieValue: true
  },
  {
    key: `${key}Fertilization`,
    name: 'Düngung (nach Nährstoffabfuhr)',
    unit: 'kg CO₂-Äq./ha',
    pieValue: true
  },
  {
    key: `${key}CropResidues`,
    name: 'Ernterückstände',
    unit: 'kg CO₂-Äq./ha',
    pieValue: true
  },
  {
    key: `${key}CropProtection`,
    name: 'Pflanzenschutz',
    unit: 'kg CO₂-Äq./ha',
    pieValue: true
  },
  {
    key: `${key}SiloMaintenance`,
    name: 'Silounterhalt und Lagerverluste',
    unit: 'kg CO₂-Äq./ha'
  },
  {
    key: `${key}DieselProductionAndCombustion`,
    name: 'Dieselherstellung und -verbrennung',
    unit: 'kg CO₂-Äq./ha',
    pieValue: true
  },
  {
    key: `${key}GhgEmissionProduction`,
    name: 'THG-Emissionen aus der Herstellung der eingesetzten Betriebsmittel',
    unit: 'kg CO₂-Äq./ha'
  },
  {
    key: `${key}GhgEmissionField`,
    name: 'THG-Emissionen aus dem Feld',
    unit: 'kg CO₂-Äq./ha'
  },
  {
    key: `${key}GhgEmissionFreshMass`,
    name: 'THG-Emissionen je kg Frischmasse',
    unit: 'kg CO₂-Äq./kg FM',
    decimal: 2
  },
  {
    key: `${key}GhgEmissionDryMatter`,
    name: 'THG-Emissionen je kg Trockenmasse',
    unit: 'kg CO₂-Äq./kg TM',
    decimal: 2
  }
]

export const heiferTableColumnHeaders = [
  {
    name: `THG-Emissionen gesamt Färsenaufzucht`,
    key: 'youngCattleTotal',
    unit: 'kg CO₂-Äq./erz. Färse',
    type: 'no-unit-number',
    total: true
  },
  {
    name: 'erzeugte Färse',
    key: 'youngCattleGhgEmissionHeifersIdf',
    unit: 'kg CO₂-Äq./je erz. Färse'
  },
  {
    name: 'weibliches Kalb',
    key: 'youngCattleFemaleCalf',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Verdauung',
    key: 'youngCattleDigestion',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Futtermittelherstellung- und verluste',
    key: 'youngCattleFeedProductionAndLosses',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Wirtschaftsdünger und Einstreu',
    key: 'youngCattleManureAndBedding',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Wasser- und Energieeinsatz',
    key: 'youngCattleWaterAndEnergy',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Dieselherstellung- und verbrennung',
    key: 'youngCattleDieselProductionAndCombustion',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  },
  {
    name: 'Maschinenherstellung',
    key: 'youngCattleMachineManufacturing',
    unit: 'kg CO₂-Äq./je erz. Färse',
    pieValue: true
  }
]

export const mainColumnHeaders = [
  {
    name: i18n.t('GHG emissions with allocation according to IDF (international comparison value) per kg of milk sold'),
    key: 'soldMilkEconomicAllocationFpcmIdf',
    type: 'no-unit-number',
    unit: 'kg CO<sub>2</sub>-Äq./kg Milch (FPCM)',
    info: `Die THG-Emissionen mit Allokation nach IDF je kg verkaufter Milch (FPCM) entsprechen den THG-Emissionen je Kuh und Jahr dividiert durch die Menge an fett- und eiweißkorrigierter, verkaufter Milch in kg aufgeteilt auf die Lebendgewicht-Erträge aus dem Verkauf des Kalbes und der Altkuh sowie der verkauften Milchmenge mit der Fett- und Eiweißkorrektur nach der Formel von IDF mit 4 % Fett und 3,3 % Eiweiß.
    Ähnlich der ökonomischen Allokation werden die Treibhausgasemissionen verursachergerecht auf die drei Produkte Kalb, Altkuh und Milch verteilt. Als Verteilungsschlüssel dient laut IDF-Standard die Ertragsmenge in kg. Dafür wird der Kälberertrag in kg Lebendgewicht, der Altkuhertrag in kg Schlachtgewicht und der Milchertrag in kg FPCM berechnet. Der Verteilungsschlüssel (Allokationsfaktor) erfolgt dann auf Grundlage der Ertragsmenge mit Berücksichtigung des jeweiligen Energiebedarfs für die Milch- und Fleischproduktion. 
    Dieser CO2-Fußabdruck dient als internationaler Vergleichswert, da er auf Basis des IDF-Standards ermittelt wurde.
    `,
    className: 'bold-cell',
    decimal: 2,
    border: '2px solid #4A90E2'
  },
  {
    name: i18n.t('GHG emissions per cow per year'),
    key: 'total',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    info: 'Dieser Wert entspricht der Summe aller berücksichtigten Treibhausgasemissionen.',
    total: 2
  },
  {
    name: 'Schlachtkuh pro kg Lebendgewicht',
    key: 'ghgEmissionSlaughterCowsIdf',
    unit: 'kg CO₂-Äq./kg',
    decimal: 2,
    border: '2px solid #4A90E2'
  },
  {
    name: 'Kalb je kg Lebendgewicht (28. Lebenstag)',
    key: 'ghgEmissionCalvesIdf',
    unit: 'kg CO₂-Äq./je kg',
    decimal: 2,
    border: '2px solid #4A90E2'
  },
  {
    name: i18n.t('GHG emissions per kg of milk sold'),
    key: 'soldMilk',
    type: 'no-unit-number',
    unit: 'kg CO<sub>2</sub>-Äq./kg Milch',
    info: `Die THG-Emissionen je kg verkaufter Milch entsprechen der Summe aller THG-Emissionen je
    Kuh und Jahr dividiert durch die Gesamtmenge der verkauften Milch in kg.`,
    decimal: 2
  },
  {
    name: i18n.t('GHG emissions with economic allocation per kg of milk sold'),
    key: 'soldMilkEconomicAllocationFpcm',
    type: 'no-unit-number',
    unit: 'kg CO<sub>2</sub>-Äq./kg Milch (FPCM)',
    info: `Die THG-Emissionen mit ökonomischer Allokation je kg verkaufter Milch (FPCM) entsprechen
    den anteiligen THG-Emissionen, unter Berücksichtigung der Milcherlöse am Gesamterlös, geteilt
    durch die verkaufte, fett- und eiweißkorrigierter Milchmenge.
    Der Betrieb erzeugt neben Milch noch weitere Produkte. Es ist daher verursachergerecht, die
    Gesamtemissionen des Produktionsverfahrens Milchkuhhaltung auf die Produkte aufzuteilen.
    Diese regelbasierte Verteilung wird als Allokation bezeichnet. Die Treibhausgasemissionen
    werden auf die drei Kategorien Milcherlös, Kälbererlös und Altkuherlös aufgeteilt. So wird
    verhindert, dass der Milch die Gesamt-Treibhausgasemissionen angelastet werden, während
    das Kalb zum Beispiel ohne Emissionen zur Kalbinnenaufzucht bzw. zur Bullenmast weiter
    verkauft werden würde.
    Dafür wird zunächst der monetäre Ertrag der drei Produkte Kälber, Altkuh und Milch berechnet.
    Mithilfe des Gesamterlöses findet eine prozentuale Aufteilung statt. Entsprechend dieser
    prozentualen Gewichtung werden die gesamten Treibhausgasemissionen den drei Produkten
    Kälber, Altkuh und Milch zugeteilt. Die Werte zur Berechnung der Erlöse stammen aus den LfL-
    Deckungsbeiträgen und Kalkulationsdaten- Milchkuhhaltung.`,
    decimal: 2
  },
  {
    name: i18n.t('Inventory addition'),
    key: 'inventoryAddition',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: i18n.t('Calf rearing'),
    key: 'calfRearing',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: 'Verdauung',
    key: 'digestion',
    pieValue: true,
    unit: 'kg CO2-Äq./Kuh u. Jahr'
  },
  {
    name: 'Futtermittelherstellung- und verluste',
    key: 'feedProductionAndLosses',
    unit: 'kg CO2-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: i18n.t('Manure and Bedding'),
    key: 'manureAndBedding',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: i18n.t('Water and Energy'),
    key: 'waterAndEnergy',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: i18n.t('Diesel Production'),
    key: 'dieselProductionAndCombustion',
    unit: 'kg CO<sub>2</sub>-Äq./Kuh u. Jahr',
    pieValue: true
  },
  {
    name: 'Maschinenherstellung',
    key: 'machineManufacturing',
    unit: 'kg CO2-Äq./Kuh u. Jahr',
    pieValue: true
  }
]